module.exports = __webpack_public_path__ + "img/background064.2ad3a015.jpg";